import { writable } from 'svelte/store';
import posthog from 'posthog-js';
import { browser } from '$app/environment';

export const flags = writable({});

function refreshFlags() {
        flags.set({
                double_referral_rewards: posthog.isFeatureEnabled('double_referral_rewards'),
                maintenance_mode: posthog.isFeatureEnabled('maintenance_mode'),
               alert_banner: posthog.isFeatureEnabled('alert_banner')
                       ? posthog.getFeatureFlagPayload('alert_banner')
                       : null,
               logout_clear_cache: posthog.isFeatureEnabled('logout_clear_cache')
                               // free_shipping: posthog.isFeatureEnabled('free_shipping'),
        });
        console.log({ flags });
}

if (browser) {
	posthog.onFeatureFlags(refreshFlags);
	refreshFlags();
}
